module.exports = __webpack_public_path__ + "static/media/info-order.e996ccdb.svg";